"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderToStaticMarkup = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _server = _interopRequireDefault(require("react-dom/server"));
//import React from 'react';

//const REACT_API_UPDATE_VERSION = 18;

/**
 * See
 * https://react.dev/reference/react-dom/server/renderToString#removing-rendertostring-from-the-client-code
 */
//const renderToStaticNew = (elem: ReturnType<typeof createElementWithSlate>) => {
// const div = document.createElement('div');
// const root = ReactDOMClient.createRoot(div);
// ReactDOM.flushSync(() => {
//   root.render(elem);
// });
//
// return div.innerHTML;
//};

var renderToStaticOld = function renderToStaticOld(elem) {
  var div = document.createElement('div');
  // eslint-disable-next-line react/no-deprecated
  _reactDom.default.render(elem, div);
  return div.innerHTML;
};
var createRenderToStaticMarkupClient = function createRenderToStaticMarkupClient() {
  //const reactMajorVersion = +React.version.slice(0, 2);

  return renderToStaticOld; //reactMajorVersion >= REACT_API_UPDATE_VERSION ? renderToStaticNew : renderToStaticOld;
};
var renderToStaticMarkup = exports.renderToStaticMarkup = typeof window === 'undefined' ? _server.default.renderToStaticMarkup : createRenderToStaticMarkupClient();